import {FC, useCallback, useEffect, useMemo} from 'react';
import {useField} from 'formik';
import dayjs from 'dayjs';
import {calculateMinDate} from '../../date_time_picker/helpers';
import DateTimePicker, {DateTimePickerProps} from '../../date_time_picker/DateTimePicker';
import {DatePickerType, DatePickerValidation} from '../../../../constants/tasks';

export interface DateTimePickerFieldProps extends DateTimePickerProps {
  now?: Nullable<string>,
  validationType?: DatePickerValidation,
  type?: DatePickerType,
  name: string;
}

const DateTimePickerField: FC<DateTimePickerFieldProps> = ({
  name,
  label,
  disabled,
  required,
  validationType,
  type,
  placeholder,
  now
}) => {
  const [
    {value},
    {error, touched},
    {setTouched, setValue}
  ] = useField(name);

  const minDate = useMemo(() => {
    return calculateMinDate(type, validationType);
  }, [type, validationType]);

  const errorMessage = value && touched && error;

  const handleChange = useCallback((newValue) => {
    setValue(newValue);
    setTouched(true);
  }, []);

  useEffect(() => {
    if (!touched && !!now) {
      setTouched(true);
      setValue(dayjs());
    }
  }, []);

  return (
    <DateTimePicker
      value={value}
      onChange={handleChange}
      minDate={minDate}
      disabled={disabled}
      label={label}
      errorMessage={errorMessage}
      showError={!!errorMessage}
      required={required}
      placeholder={placeholder}
    />
  );
};

export default DateTimePickerField;
